module.exports = __webpack_public_path__ + "static/media/result.298eab82.png";